import React from "react";
import {
  FormGroup,
  Callout,
  Intent,
  InputGroup,
  Classes
} from "@blueprintjs/core";
import styles from "./PaymentSidebar.module.scss";
import Cleave from "cleave.js/react";

export function PaymentForm({
  cardNumber,
  setCardNumber,
  cardholderName,
  setCardHolderName,
  expiration,
  setExpiration,
  cvv,
  setCvv,
  error,
  isCardNumberValid,
  isCardNameValid,
  isExpirationDateValid,
  isCvvValid,
  isCardError
}) {
  return (
    <div className={styles.paymentForm}>
      {isCardError && (
        <Callout
          intent={Intent.WARNING}
          title={error.title}
          style={{ marginBottom: "1em" }}
          icon={null}
        >
          {error.message}
        </Callout>
      )}
      <div className={styles.row}>
        <div className={styles.column}>
          <FormGroup
            label="Card Number"
            labelFor="card"
            helperText={isCardNumberValid == false && error.message}
            intent={isCardNumberValid !== false ? Intent.NONE : Intent.DANGER}
          >
            <div className="bp3-input-group">
              <Cleave
                type="tel"
                options={{ creditCard: true }}
                onChange={setCardNumber}
                value={cardNumber}
                placeholder="4242 4242 4242 4242"
                className={Classes.INPUT}
              />
            </div>
          </FormGroup>
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.column}>
          <FormGroup
            label="Name on Card"
            labelFor="name"
            helperText={isCardNameValid == false && error.message}
            intent={isCardNameValid !== false ? Intent.NONE : Intent.DANGER}
          >
            <InputGroup
              id="name"
              type="text"
              value={cardholderName}
              onChange={setCardHolderName}
              placeholder="Name on Card"
            />
          </FormGroup>
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.column}>
          <FormGroup
            label="Expiration Date"
            labelFor="exp"
            helperText={isExpirationDateValid == false && error.message}
            intent={
              isExpirationDateValid !== false ? Intent.NONE : Intent.DANGER
            }
          >
            <div className="bp3-input-group">
              <Cleave
                type="tel"
                options={{ date: true, datePattern: ["m", "y"] }}
                onChange={setExpiration}
                value={expiration}
                placeholder="MM/YY"
                className={Classes.INPUT}
              />
            </div>
          </FormGroup>
        </div>

        <div className={styles.column}>
          <FormGroup
            label="CVC"
            labelFor="cvc"
            type="tel"
            pattern="[0-9]*"
            helperText={isCvvValid == false && error.message}
            intent={isCvvValid !== false ? Intent.NONE : Intent.DANGER}
          >
            <div className="bp3-input-group">
              <Cleave
                id="cvc"
                type="tel"
                pattern="[0-9]*"
                options={{ blocks: [4], numericOnly: true }}
                value={cvv}
                onChange={setCvv}
                placeholder="CVV"
                className={Classes.INPUT}
              />
            </div>
          </FormGroup>
        </div>
      </div>
    </div>
  );
}
